var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 2.5C9.96094 2.5 10.3125 2.8498 10.3125 3.28125V5.625H19.6875V3.28125C19.6875 2.8498 20.0391 2.5 20.4688 2.5C20.8984 2.5 21.25 2.8498 21.25 3.28125V5.625H22.8125C24.5361 5.625 25.9375 7.02393 25.9375 8.75V24.375C25.9375 26.0986 24.5361 27.5 22.8125 27.5H7.1875C5.46143 27.5 4.0625 26.0986 4.0625 24.375V8.75C4.0625 7.02393 5.46143 5.625 7.1875 5.625H8.75V3.28125C8.75 2.8498 9.10156 2.5 9.53125 2.5ZM24.375 11.875H5.625V24.375C5.625 25.2393 6.32471 25.9375 7.1875 25.9375H22.8125C23.6768 25.9375 24.375 25.2393 24.375 24.375V11.875ZM22.8125 7.1875H7.1875C6.32471 7.1875 5.625 7.88574 5.625 8.75V10.3125H24.375V8.75C24.375 7.88574 23.6768 7.1875 22.8125 7.1875Z",
    fill: "#173593"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame (2).f75bc41e80195d6feaced32ebf73bb17.svg";
export { ForwardRef as ReactComponent };